//登録済みお気に入りボタンを無効化
export default function (parentElName) {
	const pname = parentElName ? parentElName + ' ' : '';
	let bookmark = localStorage.getItem("bookmark");
	let samerecipesave = localStorage.getItem("samerecipesave");
	let allBookmarks = [];
	if(samerecipesave) {
		samerecipesave = JSON.parse(samerecipesave);
		allBookmarks = Array.from(new Set([...allBookmarks, ...samerecipesave.ids]));
	}
	if(bookmark) {
		bookmark = JSON.parse(bookmark);
		allBookmarks = Array.from(new Set([...allBookmarks, ...bookmark.ids]));
		const wulikeBtns = document.querySelectorAll(pname + '.wp_ulike_btn');
		[].forEach.call(wulikeBtns, (btn) => {
			let myId = btn.dataset.ulikeId;
			const unit = btn.closest('.js-recipe-unit');
			if(unit) {
				const elDataId = unit.querySelector('[data-id]');
				if(elDataId) {
					const dataId = elDataId.getAttribute('data-id');
					myId = dataId;
				}
			}
			if(allBookmarks.includes(myId)) {
				const div = document.createElement('div');
				div.classList.add('shield');
				btn.closest('div').appendChild(div);
				btn.disabled = true;
			}
		});
	}
}
